import React from "react";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import LinktoSite from "./LinktoSite";
import Standalone from "./Standalone";
import "./index.css";
class Guides extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand_name: "",
      brand_url: "",
      page: "Standalone",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          white: res.white,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });
    }
  }

  render() {
    const { username, role, logo, brand, page } = this.state;
    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <div className="switch-bar">
          <button
            className={`btn btn-white`}
            style={{
              color:
                page === "Standalone"
                  ? this.state.white
                    ? "white"
                    : "black"
                  : "black",
              backgroundColor:
                page === "Standalone"
                  ? this.state.hex
                    ? this.state.hex
                    : "black"
                  : "white",
            }}
            onClick={() => this.setState({ page: "Standalone" })}
          >
            Iframe front end integration
          </button>
          <button
            className={`btn btn-white`}
            style={{
              color:
                page === "Link"
                  ? this.state.white
                    ? "white"
                    : "black"
                  : "black",
              backgroundColor:
                page === "Link"
                  ? this.state.hex
                    ? this.state.hex
                    : "black"
                  : "white",
            }}
            onClick={() => this.setState({ page: "Link" })}
          >
            Brand and api creation
          </button>
        </div>

        <div className="guide-container">
          {page === "Standalone" && <Standalone />}
          {page === "Link" && <LinktoSite />}
        </div>
      </div>
    );
  }
}
export default Guides;



// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Guides/index.js